export default {
  getLayout (state) {
    return state.layout
  },
  getDashboardTitle (state) {
    return state.dashboardTitle
  },
  menuData (state) {
    return state.menuData
  },
  actionType (state) {
    return state.actionType
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js